@if(viewModel()){<vy-box [noPadding]="true" [hasMarginBottom]="true">
  <ng-container box-content>
    <vy-box [noPadding]="true">
      <ng-container box-content>
        <vy-basket
          [basketStatus]="status"
          [basket]="viewModel().basket"
          [flightJourneys]="viewModel().flights"
          [hasFlightJourney]="false"
          [recordLocator]="recordLocator!"
          [showFooterAlert]="false"
        >
        </vy-basket>
      </ng-container>
    </vy-box>
  </ng-container>
</vy-box>
@if(viewModel().paymentDetails.payments?.[0]){
<vy-box [boxLevel]="boxLevelEnum.LEVEL_ONE" [noPadding]="true">
  <ng-container box-content>
    @for (payments of viewModel().paymentDetails.payments; track $index) {
    <vy-box
      [boxLevel]="boxLevelEnum.LEVEL_TWO"
      [header]="true"
      contentClass="vy-box-header_dark"
      [hasMarginBottom]="!!viewModel().paymentDetails.payments![$index + 1]"
    >
      <ng-container box-header>
        <vy-icon-text
          [type]="iconType"
          [size]="iconSize"
          [label]="'booking_details_component.payment_details_component.payment_number' | translate: { number: $index+1 }"
          [iconClass]="'ds-icon-credit-card-back'"
        >
        </vy-icon-text>
      </ng-container>

      <ng-container box-content>
        <div class="payment-details-item">
          <span>
            <vy-icon-text
              [type]="0"
              [size]="iconSize"
              [label]="'booking_details_component.payment_details_component.payment_type' | translate"
              [iconClass]="''"
            >
            </vy-icon-text>
          </span>
          <span>
            <vy-icon-text
              [type]="0"
              [size]="iconSize"
              [label]="payments.type"
              [iconClass]="paymentTypeLogo[payments.type]"
            >
            </vy-icon-text>
          </span>
        </div>
        @if(payments.cardNumber){
        <div class="payment-details-item">
          <span>
            <vy-icon-text
              [type]="0"
              [size]="iconSize"
              [label]="'booking_details_component.payment_details_component.account_number' | translate"
              [iconClass]="''"
            >
            </vy-icon-text>
          </span>
          <span> {{payments.cardNumber}} </span>
        </div>
        } @if(payments.cardHolder){
        <div class="payment-details-item">
          <span>
            <vy-icon-text
              [type]="0"
              [size]="iconSize"
              [label]="'booking_details_component.payment_details_component.account_name' | translate"
              [iconClass]="''"
            >
            </vy-icon-text>
          </span>
          <span> {{payments.cardHolder}} </span>
        </div>
        }
        <div class="payment-details-item">
          <span>
            <vy-icon-text
              [type]="0"
              [size]="iconSize"
              [label]="'booking_details_component.payment_details_component.payment_status' | translate"
              [iconClass]="''"
            >
            </vy-icon-text>
          </span>
          <vy-process-message
            [type]="processMessageType[payments.paymentStatus]"
            [size]="processMessageSize"
            [processMessageText]="currentLabelPaymentStatus[payments.paymentStatus]"
          ></vy-process-message>
        </div>
      </ng-container>
    </vy-box>
    }
  </ng-container>
</vy-box>
}}
